import React from 'react';
import i18n from '../utils/localizations.jsx';
import { PopupService } from "./popup_service.jsx";
import NotificationPopup from "../components/popups/notification_popup.jsx";
import { NotificationButtons } from "../components/popups/popup_constants.js";
import { authenticationService } from './authenticationService.js';
import tankService from './tanksService.js';

const TIMEOUT = 30000;

export const tankLevelNotificationScheduler =
{
    start,
    stop
}

let timer = 0;
let skipedTanks = [];

function start() {
    run(3000);
}

function stop() {
    clearTimeout(timer);
}

function run(timeout) {
    timer = setTimeout(checkLevelState, timeout);
}
async function checkLevelState() {
    const currentUser = authenticationService.getCurrentUser();
    if (!currentUser) {
        run(TIMEOUT);
        return;
    }

    let tanks = [];
    try {
        tanks = await tankService.getTanksSilentAsync();
    } catch (error) {
        run(TIMEOUT);
        return;
    }

    tanks = tanks ? tanks : [];
    const lowLevelTanks = tanks.filter(tank => tank.volume <= tank.minLevel);
    const withoutSkipped = tanks.filter(tank => tank.volume <= tank.minLevel)
        .filter(tank => skipedTanks.find((a) => tank.tankId === a) === undefined);

    skipedTanks = skipedTanks.filter(tank => lowLevelTanks.find((a) => tank === a.tankId));

    if (withoutSkipped.length > 0) {
        showLoLevelNotification(withoutSkipped);
    } else {
        run(TIMEOUT);
    }
}

function closePopupAction(ids) {
    skipedTanks = skipedTanks.concat(ids).filter((item, index, arr) => arr.indexOf(item) === index);
    run(TIMEOUT);
}

function showLoLevelNotification(tanks) {
    const header = i18n.t("Tanks.LoLevelNotificationPopupHeader");
    const message = i18n.t("Tanks.LoLevelNotificationPopupMessage").replace("{tanks}", tanks.map(tank => tank.fuelType).join(", "));
    let element = React.createElement(NotificationPopup,
        {
            header: header,
            message: message, 
            buttons: [ NotificationButtons.OK ],
            closePopupAction: () => {
                closePopupAction(tanks.map(tank => tank.tankId));
            },
            submitAction: () => {
                closePopupAction(tanks.map(tank => tank.tankId));
            }
        });
    PopupService.showPopup(element);
}